import { formatSubjectWithLevel } from 'shared/helpers/utils/subject-display';
import type { Subject } from 'services/api';

export const transformSubjectsToOptions = (subjects: Subject[]) => {
  return subjects.map(({ name, id, educationLevel }) => ({
    label: formatSubjectWithLevel(name, educationLevel),
    value: id,
  }));
};
